import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import { useMutation } from '@apollo/client/react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// graphql
import { PLAN_TYPES_LIST_QUERY } from 'graphql/planType/queries'
import { PLAN_TYPE_DELETE_MUTATION } from 'graphql/planType/mutations'
// components
import { IconButton } from 'components/UI'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
// constants
import { Modals } from 'constants/modals'
import { INITIAL_PER_PAGE } from 'constants/table'
// icons
import DeleteIconOrigin from '@mui/icons-material/Delete'
// themes
import { colors } from 'themes/index'
// utils
import { size } from 'polished'
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

const DeleteIcon = styled(DeleteIconOrigin)`
  && {
    ${size('24px')};
    fill: ${colors.white};
  }
`

const DeletePlanTypeButton = () => {
  const router = useRouter()

  const [deleteMutation] = useMutation(PLAN_TYPE_DELETE_MUTATION)

  const { showModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })

  const handleDeleteClick = () => {
    showModal({
      width: 'sm',
      handleConfirm: async () => {
        try {
          await deleteMutation({
            variables: {
              id: router.query.id
            },
            refetchQueries: [
              {
                query: PLAN_TYPES_LIST_QUERY,
                variables: {
                  pagination: {
                    pageSkip: 0,
                    pageTake: INITIAL_PER_PAGE
                  }
                }
              }
            ]
          })

          return router.push('/settings/plan-types')
        } catch (errors) {
          console.log('[PlanTypeActionsMenu.handleDeleteClick]: ', parseGraphQLErrorMessages(errors))
        }
      }
    })
  }

  return (
    <>
      <IconButton onClick={handleDeleteClick} description='Delete' preset='RED'>
        <DeleteIcon color='inherit' />
      </IconButton>
      <ConfirmDeleteModal header={'Delete Plan Type'}>
        Are you sure you want to delete this plan type?
      </ConfirmDeleteModal>
    </>
  )
}

export default DeletePlanTypeButton
